/**
 * @license BCP
 * (c) 2016 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

/**
 * @ngdoc config
 *
 * @description
 * Init the data provider URL and cache using status.
 */
angular.module("BCP")
  .config(['b17ServiceProvider', 'host', function (b17Service, host) {
    b17Service.setUrl(host);
    b17Service.useCache(true);
  }])
  .config(['cfpLoadingBarProvider', function(cfpLoadingBarProvider) {
    cfpLoadingBarProvider.includeSpinner = false;
  }])
  /**
   * @ngdoc config
   *
   * @description
   * Setup connection errors handling.
   */
  .config(function ($httpProvider) {
    $httpProvider.interceptors.push(function (userCache, host) {
      return {
        responseError: function (response) {
          if (response.status === 0) {
            userCache.put('lastErrorMessage', 'Could not connect to host ' + host);
            userCache.put('lastErrorCode', 503);
          } else {
            if (response.data && response.data.data && response.data.data.message) {
              userCache.put('lastErrorMessage', response.data.data.message);
              userCache.put('lastErrorInfo', response.data.data.info);
              userCache.put('lastErrorCode', response.data.data.error);
            }
          }
          return response;
        }
      };
    });
  });

})();
